import React from 'react';

import TextLoadingSkeleton from './Components/LoadingSkeletons/TextLoadingSkeleton';
import FormLoadingSkeleton from './Components/LoadingSkeletons/FormLoadingSkeleton';
import AsyncComponent from './Components/AsyncComponent/AsyncComponent';

import Logout from './Pages/Logout/Logout';
import Blacklisted from './Pages/Blacklisted/Blacklisted';
import RecoveryEntry from './Pages/Recovery/RecoveryEntry/RecoveryEntry';
import PasswordRecoveryReset from './Pages/Recovery/PasswordRecoveryReset/PasswordRecoveryReset';
import PasswordRecoveryConfirm from './Pages/Recovery/PasswordRecoveryConfirm/PasswordRecoveryConfirm';
import LoginUserContainer from './Pages/LoginUser/LoginUserContainer';

import AccountRecoveryContainer from './Pages/AccountRecovery/AccountRecoveryContainer';
import AccountRecoverySuccess from './Pages/AccountRecovery/Success/Success';

const routes = [
  {
    path: '/',
    component: props => (
      <LoginUserContainer
        {...props}
        loadingSkeleton={<FormLoadingSkeleton />}
      />
    ),
  },
  {
    path: '/deactivated',
    component: props => <Blacklisted {...props} />,
  },
  {
    path: '/logout',
    component: props => <Logout {...props} />,
  },
  {
    path: '/reactivation',
    component: props => (
      <AsyncComponent
        {...props}
        loadingSkeleton={<TextLoadingSkeleton />}
        importer={() =>
          import('./Pages/AccountReactivation/AccountReactivationContainer')
        }
      />
    ),
  },
  {
    path: '/tfa/authenticator',
    component: props => (
      <AsyncComponent
        {...props}
        loadingSkeleton={<FormLoadingSkeleton />}
        importer={() =>
          import('./Pages/TwoFactorAuthApp/TwoFactorAuthAppContainer')
        }
      />
    ),
  },
  {
    path: '/tfa/backup',
    component: props => (
      <AsyncComponent
        {...props}
        loadingSkeleton={<FormLoadingSkeleton />}
        importer={() =>
          import(
            './Pages/TwoFactorAuthBackupCode/TwoFactorAuthBackupCodeContainer'
          )
        }
      />
    ),
  },
  {
    path: '/tfa/sms',
    component: props => (
      <AsyncComponent
        {...props}
        loadingSkeleton={<FormLoadingSkeleton />}
        importer={() =>
          import('./Pages/TwoFactorAuthSms/TwoFactorAuthSmsContainer')
        }
      />
    ),
  },
  {
    path: '/recovery',
    component: props => <RecoveryEntry {...props} />,
  },
  {
    path: '/recovery/password/confirm',
    component: props => <PasswordRecoveryConfirm {...props} />,
  },
  {
    path: '/recovery/password/new',
    component: props => <PasswordRecoveryReset {...props} />,
  },
  {
    path: '/recovery/account/no-access',
    component: props => <AccountRecoveryContainer {...props} />,
  },
  {
    path: '/recovery/account/forgot-credentials',
    component: props => <AccountRecoveryContainer {...props} />,
  },
  {
    path: '/recovery/account/success',
    component: props => <AccountRecoverySuccess {...props} />,
  },
];

export default routes;
